<template>
    <el-card shadow="never" class="aui-card--fill">
        <el-col :xs="24" :md="12"
            style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;background-color: #F3F4F4;position:relative;z-index: 1;">
            <img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../../../assets/img/user-list.png" />
            收款方信息
        </el-col>
        <el-col :xs="24" :md="12"
            style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;background-color: #F3F4F4;position:relative;z-index: 1;">
            <el-form :inline="true" style="text-align: right;">
                <el-form-item>
                    <el-button type="info" @click="handleExport">导出</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="handleBack">返回</el-button>
                </el-form-item>
            </el-form>
        </el-col>
        <el-form style="padding:20px 0;" :label-width="'94px'" ref="form" :model="form" :inline="true">

            <el-row>
                <el-col :md="8" :xs="8" style="margin-top:10px;">
                    <el-form-item label="收款方" label-width="80px">
                        <el-input style="width: 100%;" v-model="form.realName" placeholder="请输入收款方"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :md="8" :xs="8" style="margin-top:10px;">
                    <el-form-item label="身份证" label-width="80px">
                        <el-input style="width: 100%;" v-model="form.idCard" placeholder="请输入身份证"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :md="8" :xs="8" style="margin-top:10px;">
                    <el-form-item label="收款账号" label-width="80px">
                        <el-input style="width: 100%;" v-model="form.bankNo" placeholder="请输入收款账号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :md="8" :xs="8" style="margin-top:10px;">
                    <el-form-item label="手机号" label-width="80px">
                        <el-input style="width: 100%;" v-model="form.phone" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :md="16" :x="16">
                    <div style="margin-right: 40px;text-align:right;margin-top:10px;">
                        <el-button type="primary" @click="handleQuery">查询</el-button>
                        <el-button type="info" @click="handleReset">重置</el-button>
                    </div>
                </el-col>
            </el-row>
            <!-- <el-col> -->
        </el-form>

        <!-- </el-col> -->

        <el-table class="table" :data="tableData" border style="width: 98%;background: #fff;margin:0 1%;">
            <el-table-column type="index" label="序号" width="50" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="taskCode" label="任务接收编号" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="realName" label="收款方" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="phone" label="手机号" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="idCard" label="身份证号" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="bankNo" label="收款账号" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="bankName" label="开户行" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="unitPrice" label="单价" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="quantity" label="数量" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="dealMoney" label="结算金额" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="amountPayable" label="企业应付金额" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="serviceCharge" label="综合服务费" header-align="center" align="center"></el-table-column>
            <el-table-column prop="preTaxAmount" label="税前金额" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="personalTaxAmount" label="个税" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="vatTaxAmount" label="增值税" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="additionalTaxAmount" label="增值附加税" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="individualAmount" label="个人实际收款金额" header-align="center" align="center">
        </el-table-column>
            <el-table-column prop="earnestAmount" label="保证金" header-align="center" align="center">
            </el-table-column>
            <el-table-column v-if="$route.params.status == 4" prop="status" label="交易状态" header-align="center"
                width="120" align="center">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status == 0" size="small" type="danger">草稿</el-tag>
                    <el-tag v-if="scope.row.status == 1" size="small" type="warning">待审核</el-tag>
                    <el-tag v-if="scope.row.status == 2" size="small">待支付</el-tag>
                    <el-tag v-if="scope.row.status == 3" size="small" type="success">已支付</el-tag>
                    <el-tag v-if="scope.row.status == 4" size="small" type="success">已到账</el-tag>
                    <el-tag v-if="scope.row.status == 5" size="small" type="danger">交易失败</el-tag>
                    <el-tag v-if="scope.row.status == 6" size="small" type="warning">重发中</el-tag>
                </template>
            </el-table-column>
            <el-table-column v-if="$hasPermission('plat:batch-settlement-list:pay') && $route.params.status == 4"
                prop="operation" label="操作" header-align="center" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.status == 5" style="word-break: break-all;white-space: wrap;" type="text"
                        size="small" class="el-button--primary" @click="openPayDia(scope.row)">重发</el-button>
                </template>
            </el-table-column>

        </el-table>
        <el-pagination background :current-page="pageObject.page" :page-sizes="[10, 20, 50, 100]"
            :page-size="pageObject.limit" :total="pageObject.total" layout="total, sizes, prev, pager, next, jumper"
            @size-change="handlePageSize" @current-change="handleCurrentPage">
        </el-pagination>
        <set-pay ref="SetPay" @refreshDataList="handleQuery"></set-pay>
    </el-card>
</template>
<script>
import Cookies from 'js-cookie';
import { addDynamicRoute } from '@/router'
import setPay from "../../set-pay.vue";
export default {
    data() {
        return {
            num: -1,
            form: {
                id: "",
                idCard: "",   //身份证
                realName: "",  //收款方
                bankNo: "",  //收款账号
                phone: "",    //手机号
            },
            tableData: [],
            pageObject: {
                page: 1,
                limit: 10,
                total: 0,
            },
        }
    },
    prop: {},
    components: { setPay },
    watch: {},
    methods: {
        //导出
        handleExport() {
            window.open(`${window.SITE_CONFIG['apiURL']}/sys/plat/deal/detail/exportBatchDetails?page=${this.pageObject.page}&limit=${this.pageObject.limit}&access_token=${Cookies.get('access_token')}&idCard=${this.form.idCard}&realName=${this.form.realName}&phone=${this.form.phone}&bankNo=${this.form.bankNo}&approvalId=${this.form.id}`)

        },
        //返回
        handleBack() {
            //   返回上级
            if (this.$route.params.parentId) {//企业开票记录详情返回
                const routeParams = {
                    routeName: 'plat-platticketrecordqy__任务详情',
                    title: `申请开票`,
                    path: 'plat/platinvoicingtasklist-add',
                    params: {
                        id: this.$route.params.parentId,
                        isThreeRoute: true
                    }
                }
                addDynamicRoute(routeParams, this.$router)
            } else {
                this.$router.back(this.num)
            }
        },
        handleQuery() {
            this.$http.get(`/sys/plat/deal/detail/isBatchSubmitDetailsPage?page=${this.pageObject.page}&limit=${this.pageObject.limit}&idCard=${this.form.idCard}&realName=${this.form.realName}&phone=${this.form.phone}&bankNo=${this.form.bankNo}&dealApprovalIds=${this.form.id}`).
                then(({ data: res }) => {
                    if (res.code == 0) {
                        res.data.list.map(item => {
                            item.dealMoney = Number(item.dealMoney).toFixed(2);
                            item.amountPayable = item.amountPayable.toFixed(2);
                            item.serviceCharge = item.serviceCharge.toFixed(2);
                            item.preTaxAmount = item.preTaxAmount ? item.preTaxAmount.toFixed(2) : '';
                            item.personalTaxAmount = item.personalTaxAmount ? item.personalTaxAmount.toFixed(2) : '';
                            item.vatTaxAmount = item.vatTaxAmount ? item.vatTaxAmount.toFixed(2) : '';
                            item.additionalTaxAmount = item.additionalTaxAmount ? item.additionalTaxAmount.toFixed(2) : '';
                            item.individualAmount = item.individualAmount ? item.individualAmount.toFixed(2) : '';
                            item.earnestAmount = item.earnestAmount ? item.earnestAmount.toFixed(2) : '';
                        })
                        this.tableData = res.data.list;
                        this.pageObject.total = res.data.total;
                    }
                })

        },
        handleReset() {
            this.form.idCard = '';
            this.form.realName = '';
            this.form.bankNo = '';
            this.form.phone = '';
            this.pageObject = {
                page: 1,
                limit: 10,
                total: 0,
            },
                this.handleQuery();
        },
        receiverSelection() {

        },
        //分页
        handlePageSize(val) {
            this.pageObject.page = 1
            this.pageObject.limit = val
            this.handleQuery()
        },
        //当前页数
        handleCurrentPage(val) {
            this.pageObject.page = val
            this.handleQuery()
        },
        // 支付
        openPayDia(row) {
            this.$refs.SetPay.init();
            this.$refs.SetPay.ids = [row.id];
            // this.$refs.SetPay.isIds = true;
            this.$refs.SetPay.parentIsErr = true;
            this.$refs.SetPay.getPayDetails();
        },
    },
    created() {
        console.log(this.$route.params)
        this.form.id = this.$route.params.id
        this.num = this.$route.params.num || -1
        this.handleQuery()
    }
}
</script>
<style lang="scss"></style>